import {useState} from 'react';

import {
    SearchRequestOptions,
    useQuerySchoolAcademicYearsSearch
} from '../../../hooks/queries/use-query-school-academic-years-search';
import {isNotFoundError} from '../../../api/utils/resolve-response-data';
import {usePreviousValue} from '../../../hooks/use-previous-value';

const INITIAL_QUERY: SearchRequestOptions = {
    request: {
        // Zero required in swagger for no value
        academicYear: 0
    },
    params: {
        PageIndex: 1,
        PageSize: 10
    }
}

export const useSchoolAcademicYearsSearch = () => {
    // on first render, do not run the search query and leave it empty
    const [isQueryEnabled, setIsQueryEnabled] = useState<boolean>(false);
    const [searchRequestOptions, setSearchRequestOptions] = useState<SearchRequestOptions>(INITIAL_QUERY);
    const previousRequestOptions = usePreviousValue(searchRequestOptions);

    const {
        data,
        isLoading,
        isFetching,
        isPreviousData,
        refetch,
        error
    } = useQuerySchoolAcademicYearsSearch(searchRequestOptions, {
        enabled: isQueryEnabled,
        refetchOnWindowFocus: false
    });

    const handleOnSearch = (input: SearchRequestOptions) => {
        let params = {...input.params};
        // need to reset pager as the paged results are unique to the request data
        if (
            previousRequestOptions.request.term !== input.request.term ||
            previousRequestOptions.request.academicYear !== input.request.academicYear
        ) {
            params = INITIAL_QUERY.params;
        }

        setSearchRequestOptions({...input, params});

        if (!isQueryEnabled) {
            setIsQueryEnabled(true);
        } else {
            refetch();
        }
    };

    // Allow not found 404 errors show an info warning
    // instead of red error message
    const isError = !!error && !isNotFoundError(error);

    return {
        isQueryEnabled,
        isError,
        isLoading,
        isPreviousData,
        isFetching,
        onSearch: handleOnSearch,
        searchRequestOptions,
        data
    };
};
